import type { User } from "@lumen/shared";
import { OrganizationWorkspace } from "./OrganizationPage";

export function OrganizationPage({
  permissions,
  user,
}: {
  permissions: string[];
  user: User;
}) {
  return (
    <OrganizationWorkspace permissions={permissions} user={user} mode="list" />
  );
}
